import { createAction } from '@reduxjs/toolkit';
import { stateName } from './constants';
export const fetchBannersRequest = createAction("".concat(stateName, "/fetchBannersRequest"), function () {
  let {
    shouldRefresh
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    payload: {
      shouldRefresh
    }
  };
});